import React, { useEffect, useState, Component } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AppBar, Toolbar, IconButton, Typography, Box, Chip } from '@mui/material';
import { Menu as MenuIcon, Logout as LogoutIcon } from '@mui/icons-material';

import { useUserData } from './hooks/useUserData';
import { useSessionTimer } from './hooks/useSessionTimer';
import { usePermissions } from './hooks/usePermissions';   // ← Importante

import Login from './components/Login';
import Usuarios from './components/Usuarios';
import Clientes from './components/Clientes';
import DatosClientes from './components/DatosClientes';
import EditarCliente from './components/EditarCliente';
import CitasCalendario from './components/CitasCalendario';
import Categorias from './components/Categorias';
import SubCategorias from './components/SubCategorias';
import Catalogo from './components/Catalogo';
import Marcas from './components/Marcas';
import Especies from './components/Especies';
import Razas from './components/Razas';
import Alergias from './components/Alergias';
import Sucursales from './components/Sucursales';
import Roles from './components/Roles';
import PetPerfil from './components/PetPerfil';
import ErrorQr from './components/ErrorQr';
import GenerarDataJS from './components/GenerarDataJS';
import ExitoSalaQr from './components/ExitoSalaQr';
import UbicacionVista from './components/UbicacionVista';
import Camaras from './components/Camaras';
import RecepcionEscanner from './components/RecepcionEscanner';
import PantallaCola from './components/PantallaCola';
import ExitoTurnoAsignado from './components/ExitoTurnoAsignado';
import PanelRecepcion from './components/PanelRecepcion';
import DocumentosFiscalesVista from './components/DocumentosFiscalesVista';
import AuditoriaDocFiscal from './components/AuditoriaDocFiscal';
import ConfirmacionTurno from './components/ConfirmacionTurno';
import ColaConsultorioServicio from './components/ColaConsultorioServicio';
import SubZonas from './components/SubZonas';
import Zonas from './components/Zonas';
import ConfiguracionDomicilio from './components/ConfiguracionDomicilio';
import LogisticaDomicilio from './components/LogisticaDomicilio';
import RutaProgramada from './components/RutaProgramada';
import HospitalizacionEvolucion from './components/HospitalizacionEvolucion';
import HospitalizadosLista from './components/HospitalizadosLista';
import HospitalizacionDetalle from './components/HospitalizacionDetalle';
import BannerPromocional from './components/BannerPromocional';
import Salas from './components/Salas';
import Consultorios from './components/Consultorios';
import DispositivosConfianza from './components/DispositivosConfianza';
import Configuraciones from './components/Configuraciones';
import VistaDiariaCitas from './components/VistaDiariaCitas';
import AuditoriaConexiones from './components/AuditoriaConexiones';    
import QrOdoo from './components/QrOdoo';

import AlbaranesGestion from './components/AlbaranesGestion';
import AlbaranDetalleView from './components/AlbaranDetalleView';
import ListasPrecioGestion from './components/ListasPrecioGestion';
import FormasPago from './components/FormasPago';      
import CierreCajaDiario from './components/CierreCajaDiario';
import ConsultaPrecios from './components/ConsultaPrecios'; 
import BackupGestion from './components/BackupGestion';
import ReportesMaestros from './components/ReportesMaestros';    
import ConfiguracionReglaPuntos from './components/ConfiguracionReglaPuntos';  
import CatalogosPremios from './components/CatalogosPremios';   
// Tema personalizado
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1e293b' },
    secondary: { main: '#4b5563' },
    background: { default: '#f1f5f9' },
  },
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: { backgroundColor: '#fff' },
      },
    },
  },
});

// Error Boundary
class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error capturado por ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Algo salió mal.</h1>
          <p>{this.state.error?.message || 'Error desconocido'}</p>
          <button onClick={() => window.location.reload()}>Recargar página</button>
        </div>
      );
    }
    return this.props.children;
  }
};

// ==================== PROTECTED CONFIG ROUTE ====================
const ProtectedConfigRoute = ({ children }) => {
  const navigate = useNavigate();
  const { canAccessConfiguraciones, user } = usePermissions();

  useEffect(() => {
    if (user && user.id_rol) {
      if (!canAccessConfiguraciones()) {
        navigate('/clientes', { replace: true });
      }
    }
  }, [user, canAccessConfiguraciones, navigate]);

  if (!user || !user.id_rol) {
    return <Box sx={{ p: 5, textAlign: 'center' }}>Cargando permisos...</Box>;
  }

  return canAccessConfiguraciones() ? children : null;
};

// ==================== PROTECTED id rol 5  ROUTE ====================

const ProtectedLogisticaRoute = ({ children }) => {
  const navigate = useNavigate();
  const { canAccessLogistica, user } = usePermissions();

  useEffect(() => {
    if (user && user.id_rol) {
      if (!canAccessLogistica()) {
        // Si no tiene acceso a logística, mandarlo al login o página de error
        navigate('/login', { replace: true });
      }
    }
  }, [user, canAccessLogistica, navigate]);

  if (!user || !user.id_rol) return <Box sx={{ p: 5 }}>Cargando...</Box>;

  return canAccessLogistica() ? children : null;
};

// ==================== PROTECTED id rol 5  ROUTE comunes menos el 5 fuera ====================

const ProtectedCommonRoute = ({ children }) => {
  const navigate = useNavigate();
  const { isRestrictedUser, user } = usePermissions();

  useEffect(() => {
    if (user && user.id_rol) {
      const rol = Number(user.id_rol);
      
      if (rol === 5) {
        navigate('/ruta-programada', { replace: true });
      } else if (rol === 4) {
        navigate('/camaras', { replace: true });
      }
      // isRestrictedUser solo para rol 5 ya no es necesario si lo manejamos aquí
    }
  }, [user, navigate]);

  return children;
};

// Títulos por ruta
const ROUTE_TITLES = {
  '/clientes': 'Clientes',
  '/usuarios': 'Usuarios',
  '/categorias': 'Categorías',
  '/subcategorias': 'Sub Categorías',
  '/catalogo': 'Catálogo',
  '/marcas': 'Marcas',
  '/especies': 'Especies',
  '/razas': 'Razas',
  '/alergias': 'Alergias',
  '/sucursales': 'Sucursales',
  '/roles': 'Roles',
  '/zonas': 'Zonas',
  '/sub-zonas': 'Sub Zonas',
  '/petperfil': 'Perfil Veterinaria',
  '/configuracion/banners': 'Banners Promocionales',
  '/dispositivos-confianza': 'Dispositivos Confianza',
  // ... agrega más si quieres
};

// ==================== GLOBAL APP BAR aqui si poner un componente le quitara la barra azul de la cabezera====================
const GlobalAppBar = ({ openSidebar, setOpenSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const userData = useUserData();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login', { replace: true });
  };

    const hideAppBarRoutes = [
    '/',
    '/pantalla-cola',
    '/exito-turno-asignado',
    '/confirmacion-turno',
    '/recepcion-escanner',
    '/error-qr',
    '/hospitalizados-lista',  
    '/hospitalizacion', 
    '/configuracion-domicilio',
    '/categorias',
    '/subcategorias', 
    '/marcas',  
    '/catalogo',  
    '/especies',  
    '/razas',
    '/alergias',
    '/sucursales',
    '/roles',
    '/zonas',
    '/sub-zonas',
    '/dispositivos-confianza', 
    '/logistica-domicilio',
    '/ruta-programada',
    '/auditoriaconexion',
    '/albaranes',
    '/cierrediario', 
    '/dtegestion', 
    '/auditoriafiscal',
    '/consultaprecios', 
    '/listas-precio',   
    '/formadepago',
    '/respaldosmiu',  
    '/consultorios',
    '/catalogosPremios',
    '/configura_reglas_puntos',     
  ];

  const shouldHideAppBar = hideAppBarRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/clientes/') ||
    location.pathname.startsWith('/hospitalizacion/') ||
    location.pathname.startsWith('/albaranes/');

  if (shouldHideAppBar) return null;

  const title = ROUTE_TITLES[location.pathname] || 'Sistema Veterinario';

  return (
    <AppBar position="fixed" sx={{ bgcolor: '#0f172a', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <IconButton color="inherit" onClick={() => setOpenSidebar(!openSidebar)} sx={{ mr: 2 }}>
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
          {userData.nombre_usuario && <Chip label={userData.nombre_usuario} size="small" sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: 'white', fontSize: '1rem'  }} />}
          {userData.id_usuario && <Chip label={`ID:${userData.id_usuario}`} size="small" sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: 'white', fontSize: '1rem' }} />}
          {userData.nombre_sucursal && <Chip label={userData.nombre_sucursal} size="small" sx={{ bgcolor: 'rgba(255,255,255,0.15)', color: 'white', fontSize: '1rem' }} />}
          <IconButton color="inherit" onClick={handleLogout}>
            <LogoutIcon fontSize="small" />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

// ==================== PROTECTED ROUTE ====================
const ProtectedRoute = ({ children, openSidebar, setOpenSidebar }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useSessionTimer();

  useEffect(() => {
    if (!token) navigate('/login', { replace: true });
  }, [token, navigate]);

  if (!token) return null;

  return (
    <>
      <GlobalAppBar openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
      {children}
    </>
  );
};

// ==================== MAIN APP ====================
function App() {
  const [openSidebar, setOpenSidebar] = useState(true);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Login />} />

            {/* Rutas de Configuración (Protegidas) */}
            <Route path="/configuraciones" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute>
                  <Configuraciones openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
                </ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/roles" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Roles /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/usuarios" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Usuarios /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/sucursales" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Sucursales /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/categorias" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Categorias /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/subcategorias" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><SubCategorias /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/catalogo" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Catalogo /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/marcas" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Marcas /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/especies" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Especies /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/razas" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Razas /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/alergias" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Alergias /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/zonas" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Zonas /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/sub-zonas" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><SubZonas /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/consultorios" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><Consultorios /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/petperfil" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><PetPerfil /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/dispositivos-confianza" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><DispositivosConfianza /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/configuracion/banners" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><BannerPromocional /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

             <Route path="/auditoriaconexion" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><AuditoriaConexiones /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/qr-odoo" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><QrOdoo /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/albaranes" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><AlbaranesGestion /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/albaranes/detalle/:id" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><AlbaranDetalleView /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/listas-precio" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><ListasPrecioGestion /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/formadepago" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><FormasPago /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

             <Route path="/dtegestion" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><DocumentosFiscalesVista /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/cierrediario" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><CierreCajaDiario /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

            <Route path="/auditoriafiscal" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedConfigRoute><AuditoriaDocFiscal /></ProtectedConfigRoute>
              </ProtectedRoute>
            } />

                 <Route path="/consultaprecios" element={
                  <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                    <ProtectedConfigRoute>
                      <ConsultaPrecios standalone />
                    </ProtectedConfigRoute>
                  </ProtectedRoute>
                } />

                <Route path="/respaldosmiu" element={
                  <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                    <ProtectedConfigRoute>
                      <BackupGestion standalone />
                    </ProtectedConfigRoute>
                  </ProtectedRoute>
                } />

                <Route path="/reportes_maestros" element={
                  <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                    <ProtectedConfigRoute>
                      <ReportesMaestros standalone />
                    </ProtectedConfigRoute>
                  </ProtectedRoute>
                } />

                <Route path="/configura_reglas_puntos" element={
                  <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                    <ProtectedConfigRoute>
                      <ConfiguracionReglaPuntos standalone />
                    </ProtectedConfigRoute>
                  </ProtectedRoute>
                } />

                <Route path="/catalogosPremios" element={
                  <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                    <ProtectedConfigRoute>
                      <CatalogosPremios standalone />
                    </ProtectedConfigRoute>
                  </ProtectedRoute>
                } />

                


                


          
            {/* Otras rutas normales */}
            <Route path="/clientes" element={
              <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}>
                <ProtectedCommonRoute>
                  <Clientes openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} />
                </ProtectedCommonRoute>
              </ProtectedRoute>
            } />

            <Route path="/clientes/:id" element={<ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}> <ProtectedCommonRoute> <DatosClientes /> </ProtectedCommonRoute> </ProtectedRoute>} />
            <Route path="/clientes/:id/edit" element={<ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}> <ProtectedCommonRoute> <EditarCliente /> </ProtectedCommonRoute> </ProtectedRoute>} />

            <Route path="/citas/calendario" element={<ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}> < ProtectedCommonRoute><CitasCalendario /> </ProtectedCommonRoute> </ProtectedRoute>} />

            <Route path="/citas/calendario/:id" element={<ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}><CitasCalendario /></ProtectedRoute>} />
            
            <Route path="/vistadiariacitas" element={ <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}> <ProtectedCommonRoute> <VistaDiariaCitas openSidebar={openSidebar} setOpenSidebar={setOpenSidebar} /> </ProtectedCommonRoute> </ProtectedRoute>} />  
            
            <Route path="/configuracion-domicilio" element={<ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}> <ProtectedCommonRoute> <ConfiguracionDomicilio /> </ProtectedCommonRoute> </ProtectedRoute>} />
            <Route path="/logistica-domicilio" element={<ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}> <ProtectedCommonRoute> <LogisticaDomicilio /> </ProtectedCommonRoute> </ProtectedRoute>} />
            
            <Route path="/ruta-programada" element={ <ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}> <RutaProgramada />  </ProtectedRoute> } />

            <Route path="/hospitalizados-lista" element={<ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}> <ProtectedCommonRoute> <HospitalizadosLista /> </ProtectedCommonRoute></ProtectedRoute>} />
            <Route path="/hospitalizacion/:id" element={<ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}> <ProtectedCommonRoute> <HospitalizacionDetalle /> </ProtectedCommonRoute> </ProtectedRoute>} />
            <Route path="/hospitalizacion" element={<ProtectedRoute openSidebar={openSidebar} setOpenSidebar={setOpenSidebar}> <ProtectedCommonRoute> <HospitalizacionEvolucion /> </ProtectedCommonRoute> </ProtectedRoute>} />

            {/* Rutas Públicas */}
            <Route path="/salas" element={<ProtectedCommonRoute> <Salas /> </ProtectedCommonRoute>} />
            <Route path="/generar-datajs" element={<ProtectedCommonRoute> <GenerarDataJS /> </ProtectedCommonRoute>} />
            <Route path="/ubicaciones" element={<UbicacionVista />} />
            <Route path="/camaras" element={ <Camaras />  } />
            <Route path="/recepcion-escanner" element={<ProtectedCommonRoute> <RecepcionEscanner /> </ProtectedCommonRoute>} />
            <Route path="/pantalla-cola" element={<ProtectedCommonRoute> <PantallaCola /> </ProtectedCommonRoute>} />
            <Route path="/cola-consultorio-servicio" element={<ProtectedCommonRoute> <ColaConsultorioServicio /> </ProtectedCommonRoute>} />
            <Route path="/confirmacion-turno" element={<ConfirmacionTurno />} />
            <Route path="/exito-sala" element={<ExitoSalaQr />} />
            <Route path="/exito-turno-asignado" element={<ExitoTurnoAsignado />} />
            <Route path="/recepcion-panel" element={<ProtectedCommonRoute> <PanelRecepcion /> </ProtectedCommonRoute>} />
            <Route path="/error-qr" element={<ErrorQr />} />

            <Route path="*" element={<div>404 - Página no encontrada</div>} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;